import React from "react";
import { ChevronLeft } from "lucide-react";

const MainContentDetail = () => {
  const content = {
    image: "/assets/event-3.png",
    title: "Community Picnic",
    type: "Event",
    description:
      "Join us for a fun-filled community picnic at Central Park. Bring your friends and family!",
    creator: "Nina & Rob, Sophia Clark (Organizer)",
    id: "#12435",
    date: "July 15, 2024",
    reports: 3,
  };

  const reportReasons = [
    {
      reason: "Inappropriate Content",
      reporter: "Ethan Carter",
      date: "July 18, 2024",
    },
    { reason: "Spam", reporter: "Olivia Bennett", date: "July 16, 2024" },
    { reason: "Harassment", reporter: "Liam Foster", date: "July 15, 2024" },
  ];

  return (
    <div className="my-8 w-[90%]">
      <div className="flex items-center -ml-2">
        <ChevronLeft size={24} className="cursor-pointer" />
        <h1 className="text-xl lg:text-2xl font-popinsSemiBold">
          Content Details
        </h1>
      </div>
      <p className="text-sm text-gray-500 mt-1 font-popinsRegular">
        Review and manage flagged content
      </p>

      <div className="mt-8">
        <h2 className="text-lg font-popinsSemiBold mb-4">Content Preview</h2>
        <div className="flex flex-col md:flex-row md:justify-between gap-3 items-center">
          <div className="w-[30%]">
            <img
              src={content.image}
              alt="Content Preview"
              className="w-full h-44 object-cover rounded-lg shadow-sm"
            />
          </div>
          <div className="w-[68%]">
            <h2 className="text-xl font-popinsSemiBold">{content.title}</h2>
            <p className="text-black/50 text-base font-popinsRegular">
              {content.type}
            </p>
            <p className="text-black/50 text-base leading-relaxed font-popinsRegular mt-1">
              {content.description}
            </p>
          </div>
        </div>
      </div>

      {/* Metadata */}
      <h3 className="text-xl font-popinsSemiBold mt-8 border-b border-black/10 pb-5">
        Metadata
      </h3>
      <div className="border-b border-black/10 pb-5 mt-5">
        <div className="flex lg:w-[70%]">
          <div className="lg:w-[50%]">
            <p className="font-popinsRegular text-sm text-black/50">
              Content Type & ID
            </p>
            <p className="font-popinsRegular">
              {content.type} {content.id}
            </p>
          </div>
          <div className="lg:w-[50%]">
            <p className="font-popinsRegular text-sm text-black/50">
              Creator Name & Role
            </p>
            <p className="font-popinsRegular">{content.creator}</p>
          </div>
        </div>
      </div>
      <div className="flex mt-5 lg:w-[70%]">
        <div className="lg:w-[50%]">
          <p className="font-popinsRegular text-sm text-black/50">
            Date Created
          </p>
          <p className="font-popinsRegular">{content.date}</p>
        </div>

        <div className="lg:w-[50%]">
          <p className="font-popinsRegular text-sm text-black/50">
            Number of Reports
          </p>
          <p className="font-popinsRegular">{content.reports}</p>
        </div>
      </div>

      {/* Report Reasons */}
      <div className="mt-12">
        <h3 className="text-xl font-popinsSemiBold mb-5">
          Report Reasons
        </h3>
        <div className="space-y-5">
          {reportReasons.map((r, i) => (
            <div key={i} className="">
              <p className="font-popinsMedium text-base">{r.reason}</p>
              <p className="font-popinsRegular text-black/50 text-sm">
                Reported by {r.reporter} ({r.date})
              </p>
              <p className="font-popinsRegular text-black/50 text-sm">Inappropriate Content</p>
            </div>
          ))}
        </div>
      </div>

      {/* Previous Actions History */}
      <div className="mt-10">
        <h3 className="text-xl font-popinsSemiBold mb-3">
          Previous Actions History
        </h3>
        <p className="text-base font-popinsRegular ml-1">No previous actions taken</p>
      </div>

      {/* Actions */}
      <div className="mt-10">
        <h3 className="text-xl font-popinsSemiBold mb-4">Actions</h3>

        <div className="flex flex-col sm:flex-row justify-end flex-wrap gap-3">
          <button className="bg-themeColor text-white px-5 py-3 rounded-md text-sm hover:bg-themeColor/90 font-popinsMedium transition">
            Remove Content
          </button>
          <button className="bg-gray-200 text-black px-5 py-2 font-popinsMedium rounded-md text-sm hover:bg-gray-100 transition">
            Warn User
          </button>
          <button className="bg-gray-200 text-black px-5 py-2 font-popinsMedium rounded-md text-sm hover:bg-gray-100 transition">
            Suspend Account
          </button>
        </div>
      </div>
      <div className="flex justify-between mt-6">
        <p className="font-popinsSemiBold text-base">Archive Report</p>
        <p className="font-popinsSemiBold text-base">Escalate</p>
      </div>
    </div>
  );
};

export default MainContentDetail;
